import { RouteType } from "../@types/RouteType";
import { DashboardRoutes, OrderRoutes, RegistrationRoutes, WarrantyClaimRoutes, TechSupportRoutes, LeadsRoutes, ResourcesRoutes, GeneralRoutes } from "./MainRoutes";

const InternationalDealerSalesRoutes: RouteType[] = [
    ...DashboardRoutes,
    ...OrderRoutes,
    ...RegistrationRoutes,
    ...WarrantyClaimRoutes,
    ...TechSupportRoutes,
    ...LeadsRoutes,
    ...ResourcesRoutes,
    ...GeneralRoutes
]

export default InternationalDealerSalesRoutes;